export enum MCTChartType {
  SimpleChart = 'Simple',
  TimeLineChart = 'Timeline',
  HeatMapChart = 'HeatMap',
  PieEntriesChart = 'Trap Entry Patterns',
  PieActivationsChart = 'Snap Activations',
}
export enum ChartTypeSRBM {
  BaitStationChart = 'Bait Station Chart',
  HeatMapChart = 'HeatMap',
}
